import { render, staticRenderFns } from "./table-idea.vue?vue&type=template&id=202e4b58&scoped=true"
import script from "./table-idea.vue?vue&type=script&lang=js"
export * from "./table-idea.vue?vue&type=script&lang=js"
import style0 from "./table-idea.vue?vue&type=style&index=0&id=202e4b58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202e4b58",
  null
  
)

export default component.exports